// Visual roles. `backend` lists the real RIPP components each role groups (checked against the codebase);
// the character shapes, names and colours are artistic mappings, not separate running programs.
export const AGENTS = [
  {
    id: "scout", name: "Scout", color: "#22D3EE", shape: "Dart", motion: "Fast, darting sweeps",
    task: "Discovers new launches and emerging activity.",
    backend: ["Pump.fun real-time launch stream (PumpPortal)", "DexScreener + Jupiter discovery adapter", "Launcher watch for known token creators"],
  },
  {
    id: "tracker", name: "Tracker", color: "#FBBF24", shape: "Ring", motion: "Orbits and follows flows",
    task: "Investigates wallet flows and who is participating.",
    backend: ["Wallet-flow specialist agent", "Holder-structure gate (clustered or airdropped wallets)", "Copy-wallet watch on tracked wallets"],
  },
  {
    id: "sentinel", name: "Sentinel", color: "#34D399", shape: "Shielded crystal", motion: "Slow, steady scans",
    task: "Examines contract, ownership and liquidity risks.",
    backend: ["Token Safety Engine (deterministic hard gate)", "Risk and liquidity specialist agents", "Low-cap guard ($25k minimum pool liquidity)"],
  },
  {
    id: "executor", name: "Executor", color: "#FB923C", shape: "Block", motion: "Direct, decisive lines",
    task: "Handles approved orders and confirmation of execution.",
    backend: ["Execution quality gate (net edge after fees and impact)", "Jupiter order → sign → execute → on-chain fill", "Risk daemon for hard exits from live sell quotes"],
  },
  {
    id: "analyst", name: "Analyst", color: "#C084FC", shape: "Faceted core with satellites", motion: "Hovers and records",
    task: "Monitors outcomes and records the results.",
    backend: ["Position book: TP ladder, runner trailing, protective stops", "Profit harvester and dynamic profit protection", "Decision log (why, downside, verification)"],
  },
  {
    id: "grok", name: "GrokBot", color: "#E5E7EB", shape: "X glyph", motion: "Streams findings from X",
    task: "Extracts relevant context from X and sends findings into the Hive. It supplies information; it never places orders.",
    backend: ["Grok X-intel scans (narratives, contract addresses copied from posts, narrative score)"],
  },
];

export const ORACLE = {
  id: "oracle", name: "The Oracle", color: "#8B5CF6",
  task: "The central coordinating intelligence. It receives findings, brings the evidence together and decides what moves to the next stage.",
  backend: ["Hive Brain opportunity funnel (discovery → verification → trade / watch / reject)", "Consensus and risk supervisor", "Hive council of five specialist agents"],
};

export const AGENT_BY_ID = Object.fromEntries([...AGENTS, ORACLE].map((a) => [a.id, a]));
